import { createAction } from "redux-actions";

// GET ALL STATES
export const GET_ALL_STATES = "GET_ALL_STATES";
export const getAllStates = createAction(GET_ALL_STATES);

export const GET_ALL_STATES_FAILURE = "GET_ALL_STATES_FAILURE";
export const getAllStatesFailure = createAction(GET_ALL_STATES_FAILURE);

export const GET_ALL_STATES_SUCCESS = "GET_ALL_STATES_SUCCESS";
export const getAllStatesSuccess = createAction(GET_ALL_STATES_SUCCESS);

// GET ALL DISTRICTS
export const GET_ALL_DISTRICTS = "GET_ALL_DISTRICTS";
export const getAllDistricts = createAction(GET_ALL_DISTRICTS);

export const GET_ALL_DISTRICTS_FAILURE = "GET_ALL_DISTRICTS_FAILURE";
export const getAllDistrictsFailure = createAction(GET_ALL_DISTRICTS_FAILURE);

export const GET_ALL_DISTRICTS_SUCCESS = "GET_ALL_DISTRICTS_SUCCESS";
export const getAllDistrictsSuccess = createAction(GET_ALL_DISTRICTS_SUCCESS);

// GET ALL TEHSILS
export const GET_ALL_TEHSILS = "GET_ALL_TEHSILS";
export const getAllTehsils = createAction(GET_ALL_TEHSILS);

export const GET_ALL_TEHSILS_FAILURE = "GET_ALL_TEHSILS_FAILURE";
export const getAllTehsilsFailure = createAction(GET_ALL_TEHSILS_FAILURE);

export const GET_ALL_TEHSILS_SUCCESS = "GET_ALL_TEHSILS_SUCCESS";
export const getAllTehsilsSuccess = createAction(GET_ALL_TEHSILS_SUCCESS);

// GET ALL DEALERS
export const GET_ALL_DEALERS = "GET_ALL_DEALERS";
export const getAllDealers = createAction(GET_ALL_DEALERS);

export const GET_ALL_DEALERS_FAILURE = "GET_ALL_DEALERS_FAILURE";
export const getAllDealersFailure = createAction(GET_ALL_DEALERS_FAILURE);

export const GET_ALL_DEALERS_SUCCESS = "GET_ALL_DEALERS_SUCCESS";
export const getAllDealersSuccess = createAction(GET_ALL_DEALERS_SUCCESS);
